import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { DeselectPackage, SelectPackage } from '../../actions/packages';
import {
    AddTicket,
    ConfirmTickets,
    RemoveTicket,
    SelectTicket,
    SelectTicketType,
} from '../../actions/tickets';

import { LockStockDialog } from '../../components/dialogs/lock-stock';
import { PackageTable } from '../../components/single-product/PackageTable';
import { getThemeFileUri, translate } from '../../utils/wp.js';

export function PackageSelector() {
    const [lockStockDialogVisible, setLockStockDialogVisible] = useState(false);

    const isLoadingPackages = useSelector(state => state.data.is_loading_packages);
    const hasLoadedPackages = useSelector(state => state.data.has_loaded_packages);
    const packagesByMonth = useSelector(state => state.data.packages_by_month);

    const selectedPackage = useSelector(state => state.packages.selected_package);

    const selectedTicket = useSelector(state => state.tickets.selected_ticket);
    const selectedTicketType = useSelector(state => state.tickets.selected_ticket_type);
    const confirmedTickets = useSelector(state => state.cart.confirmed_tickets);
    const confirmedPackage = useSelector(state => state.cart.confirmed_package);
    const addedTickets = useSelector(state => state.tickets.added_tickets);
    const ticketTypes = useSelector(state => state.tickets.ticket_types);
    const stepTicketsDone = useSelector(state => state.tickets.step_tickets_done);

    const dispatch = useDispatch();

    function onSelectTicket(ticket) {
        dispatch(SelectTicket(ticket));
    }

    function onSelectTicketType(value) {
        dispatch(SelectTicketType(value));
    }

    function onSelectPackage(pkg) {
        dispatch(SelectPackage(pkg));
    }

    function onDeselectPackage() {
        dispatch(DeselectPackage());
    }

    function addTicket(ticket) {
        if (!stepTicketsDone) {
            dispatch(AddTicket(ticket));
        }
    }

    function removeTicket(ticket) {
        if (!stepTicketsDone) {
            dispatch(RemoveTicket(ticket));
        }
    }

    function onConfirmTickets() {
        const stock = addedTickets[0].stock;
        if (stock - addedTickets.length === 1) {
            setLockStockDialogVisible(true);
        } else {
            dispatch(ConfirmTickets(selectedPackage, addedTickets));
        }
    }

    if (hasLoadedPackages && packagesByMonth.length === 0) {
        return (
            <div className="px-4 py-3 mb-2 bg-white rounded flex items-center justify-center gap-x-3 text-xs text-red font-semibold">
                <p>
                    <i className="icon-info text-[16px]"></i>
                    <span>Detta evenemang har utgått!</span>
                </p>
            </div>
        );
    }

    return (
        <div className="step packages">
            <LockStockDialog
                visible={lockStockDialogVisible}
                onClick={() => setLockStockDialogVisible(false)}
                onClose={() => setLockStockDialogVisible(false)}
            />

            <div>
                <div className="relative pb-4 md:pb-6 flex items-center justify-center">
                    <span className="text-lg font-bold">{translate(
                        'select_date_and_tickets')}</span>
                </div>

                <div className="package-list">
                    {isLoadingPackages &&
                        <div className="w-[64px] h-[64px] p-2 mx-auto bg-white rounded-full border border-primary">
                            <video
                                className="rounded-full"
                                controls={false}
                                autoPlay={true}
                                muted={true}
                                loop={true}
                            >
                                <source
                                    src={getThemeFileUri(
                                        'static/images/loader.webm')}
                                    type="video/webm"
                                />
                            </video>
                        </div>
                    }

                    {hasLoadedPackages && !isLoadingPackages &&
                        <PackageTable
                            confirmedTickets={confirmedTickets}
                            onSelectTicketType={onSelectTicketType}
                            packages={packagesByMonth}
                            selectedTicket={selectedTicket}
                            selectedTicketType={selectedTicketType}
                            selectedPackage={selectedPackage}
                            ticketTypes={ticketTypes}
                            confirmedPackage={confirmedPackage}
                            addedTickets={addedTickets}
                            addTicket={addTicket}
                            removeTicket={removeTicket}
                            stepTicketDone={stepTicketsDone}
                            onSelectTicket={onSelectTicket}
                            onSelectPackage={onSelectPackage}
                            onConfirmTickets={onConfirmTickets}
                            onDeselectPackage={onDeselectPackage}
                        />
                    }
                </div>
            </div>
        </div>
    );
}
